import { render, staticRenderFns } from "./DashboardWidgetBauberatungen.vue?vue&type=template&id=65ec502e&scoped=true"
import script from "./DashboardWidgetBauberatungen.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetBauberatungen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ec502e",
  null
  
)

export default component.exports